const API_URL = '/api/settings';

class SettingsService {
    getSubdomain() {
        const hostname = window.location.hostname;
        // localhost or IP — no subdomain
        if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return null;
        const parts = hostname.split('.');
        // e.g., acme.configselect.com → 3 parts → subdomain = "acme"
        // configselect.com → 2 parts → no subdomain
        if (parts.length >= 3) return parts[0];
        return null;
    }

    async getPublicSettings() {
        try {
            const subdomain = this.getSubdomain();
            const url = subdomain
                ? `${API_URL}/public?subdomain=${encodeURIComponent(subdomain)}`
                : `${API_URL}/public`;
            const response = await fetch(url);
            if (!response.ok) return {};
            return await response.json();
        } catch {
            return {};
        }
    }

    async getAll() {
        const response = await fetch(API_URL, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch settings');
        return await response.json();
    }

    async getByCategory(category) {
        const response = await fetch(`${API_URL}/category/${category}`, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch settings');
        return await response.json();
    }

    async update(key, value, category) {
        const response = await fetch(`${API_URL}/${key}`, {
            method: 'PUT',
            headers: this.getHeaders(),
            body: JSON.stringify({ value, category })
        });
        if (!response.ok) throw new Error('Failed to update setting');
        return await response.json();
    }

    async bulkUpdate(settings) {
        const response = await fetch(`${API_URL}/bulk`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(settings)
        });
        if (!response.ok) throw new Error('Failed to update settings');
        return await response.json();
    }

    async getDownloadSettings() {
        const response = await fetch('/api/company/download-settings', {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch download settings');
        return await response.json();
    }

    async updateDownloadSettings(settings) {
        const response = await fetch('/api/company/download-settings', {
            method: 'PUT',
            headers: this.getHeaders(),
            body: JSON.stringify(settings)
        });
        if (!response.ok) throw new Error('Failed to update download settings');
        return await response.json();
    }

    async getSmtpSettings() {
        const response = await fetch(`${API_URL}/system/smtp`, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch SMTP settings');
        return await response.json();
    }

    async updateSmtpSettings(settings) {
        const response = await fetch(`${API_URL}/system/smtp`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(settings)
        });
        if (!response.ok) throw new Error('Failed to update SMTP settings');
        return await response.json();
    }

    async uploadLogo(key, file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('key', key);

        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/upload-logo`, {
            method: 'POST',
            headers: {
                ...(token && { 'Authorization': `Bearer ${token}` })
            },
            body: formData
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Failed to upload logo');
        return data;
    }

    async sendTestEmail(to) {
        const response = await fetch(`${API_URL}/test-email`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify({ to })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Failed to send test email');
        return data;
    }

    getHeaders() {
        const token = localStorage.getItem('token');
        return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        };
    }
}

export default new SettingsService();